// Enum for table columns (API response fields)
export enum NpdTableColumn {
  CODE = "code",
  COMPANY_NAME = "company_name",
  PRODUCT_NAME = "product_name",
  SPECIFICATION = "specification",
  QUANTITY = "quantity",
  GROUP_NAME = "group_name",
  PHONE = "phone",
}

// Enum for export columns (backend expected fields)
export enum NpdExportColumn {
  CODE = "code",
  COMPANY_NAME = "company_name",
  PRODUCT_NAME = "product_name",
  SPECIFICATION = "specification",
  QUANTITY = "quantity",
  GROUP_NAME = "group__name",
  PHONE = "phone",
}

// Column display names mapping (for UI)
export const NpdColumnLabels: Record<NpdTableColumn, string> = {
  [NpdTableColumn.CODE]: "Code",
  [NpdTableColumn.COMPANY_NAME]: "Company Name",
  [NpdTableColumn.PRODUCT_NAME]: "Product",
  [NpdTableColumn.SPECIFICATION]: "Specification",
  [NpdTableColumn.QUANTITY]: "Qty",
  [NpdTableColumn.GROUP_NAME]: "Group",
  [NpdTableColumn.PHONE]: "Contact",
};

// Default selected columns for export (all true)
export const getDefaultNpdSelectedColumns = () => ({
  [NpdExportColumn.CODE]: true,
  [NpdExportColumn.COMPANY_NAME]: true,
  [NpdExportColumn.PRODUCT_NAME]: true,
  [NpdExportColumn.SPECIFICATION]: true,
  [NpdExportColumn.QUANTITY]: true,
  [NpdExportColumn.GROUP_NAME]: true,
  [NpdExportColumn.PHONE]: true,
});
